import { Course } from '../types';

export const courses: Course[] = [
  {
    id: '1',
    title: 'Desarrollo Web Full Stack con React y Node.js',
    description: 'Aprende a crear aplicaciones web completas desde cero. Desde el frontend con React hasta el backend con Node.js, bases de datos y despliegue en producción.',
    shortDescription: 'Domina el desarrollo web completo con las tecnologías más demandadas del mercado.',
    price: 299.99,
    originalPrice: 599.99,
    image: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=800&h=600&fit=crop',
    category: 'Desarrollo Web',
    duration: '40 horas',
    level: 'Intermedio',
    instructor: 'Carlos Rodríguez',
    students: 1247,
    lessons: 156,
    features: [
      'Acceso de por vida',
      'Certificado de finalización',
      'Acceso móvil',
      'Proyectos prácticos',
      'Soporte 24/7',
      'Actualizaciones gratuitas'
    ],
    requirements: [
      'Conocimientos básicos de HTML y CSS',
      'JavaScript básico',
      'Computadora con Windows, Mac o Linux'
    ],
    whatYouWillLearn: [
      'Crear aplicaciones React modernas',
      'Desarrollar APIs RESTful con Node.js',
      'Trabajar con bases de datos MongoDB',
      'Implementar autenticación JWT',
      'Desplegar aplicaciones en la nube',
      'Optimizar el rendimiento web'
    ],
    certificate: true,
    lifetimeAccess: true,
    mobileAccess: true
  },
  {
    id: '2',
    title: 'Marketing Digital: Estrategias para el Éxito Online',
    description: 'Domina las estrategias de marketing digital más efectivas. Desde SEO y SEM hasta redes sociales y email marketing, aprende a generar resultados medibles.',
    shortDescription: 'Estrategias comprobadas de marketing digital para hacer crecer tu negocio.',
    price: 199.99,
    originalPrice: 399.99,
    image: 'https://images.unsplash.com/photo-1557838923-2985c318be48?w=800&h=600&fit=crop',
    category: 'Marketing',
    duration: '25 horas',
    level: 'Principiante',
    instructor: 'Ana Martínez',
    students: 2156,
    lessons: 98,
    features: [
      'Acceso de por vida',
      'Certificado de finalización',
      'Acceso móvil',
      'Plantillas descargables',
      'Soporte 24/7',
      'Comunidad privada'
    ],
    requirements: [
      'No se requieren conocimientos previos',
      'Computadora con conexión a internet',
      'Ganas de aprender y aplicar'
    ],
    whatYouWillLearn: [
      'Optimización SEO para motores de búsqueda',
      'Campañas publicitarias en Google Ads',
      'Estrategias de contenido en redes sociales',
      'Email marketing efectivo',
      'Análisis de datos y métricas',
      'Automatización de marketing'
    ],
    certificate: true,
    lifetimeAccess: true,
    mobileAccess: true
  },
  {
    id: '3',
    title: 'Inteligencia Artificial y Machine Learning',
    description: 'Introduce en el mundo de la IA y ML. Aprende a crear modelos predictivos, procesar datos y desarrollar aplicaciones inteligentes con Python.',
    shortDescription: 'Fundamentos de IA y ML para resolver problemas reales con datos.',
    price: 399.99,
    originalPrice: 799.99,
    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&h=600&fit=crop',
    category: 'Inteligencia Artificial',
    duration: '50 horas',
    level: 'Avanzado',
    instructor: 'Dr. Luis Fernández',
    students: 892,
    lessons: 203,
    features: [
      'Acceso de por vida',
      'Certificado de finalización',
      'Acceso móvil',
      'Proyectos con datasets reales',
      'Soporte especializado',
      'Actualizaciones de contenido'
    ],
    requirements: [
      'Python intermedio',
      'Matemáticas básicas',
      'Conocimientos de estadística',
      'Computadora potente recomendada'
    ],
    whatYouWillLearn: [
      'Fundamentos de machine learning',
      'Algoritmos de clasificación y regresión',
      'Deep learning con TensorFlow',
      'Procesamiento de lenguaje natural',
      'Computer vision',
      'Despliegue de modelos en producción'
    ],
    certificate: true,
    lifetimeAccess: true,
    mobileAccess: true
  },
  {
    id: '4',
    title: 'Diseño UX/UI: Crear Experiencias Digitales Excepcionales',
    description: 'Aprende a diseñar interfaces de usuario intuitivas y experiencias digitales memorables. Desde wireframes hasta prototipos interactivos.',
    shortDescription: 'Diseña experiencias digitales que los usuarios amarán usar.',
    price: 249.99,
    originalPrice: 499.99,
    image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800&h=600&fit=crop',
    category: 'Diseño',
    duration: '30 horas',
    level: 'Intermedio',
    instructor: 'María González',
    students: 1567,
    lessons: 127,
    features: [
      'Acceso de por vida',
      'Certificado de finalización',
      'Acceso móvil',
      'Archivos de diseño incluidos',
      'Soporte 24/7',
      'Portfolio de proyectos'
    ],
    requirements: [
      'Conocimientos básicos de diseño',
      'Computadora con Figma (gratuito)',
      'Creatividad y atención al detalle'
    ],
    whatYouWillLearn: [
      'Principios de UX/UI design',
      'Investigación de usuarios',
      'Wireframing y prototyping',
      'Diseño de sistemas',
      'Testing y iteración',
      'Presentación de proyectos'
    ],
    certificate: true,
    lifetimeAccess: true,
    mobileAccess: true
  },
  {
    id: '5',
    title: 'Finanzas Personales: Construye tu Libertad Financiera',
    description: 'Toma el control de tus finanzas personales. Aprende a ahorrar, invertir y crear múltiples fuentes de ingresos para alcanzar la libertad financiera.',
    shortDescription: 'Estrategias probadas para mejorar tus finanzas personales y crear riqueza.',
    price: 149.99,
    originalPrice: 299.99,
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&h=600&fit=crop',
    category: 'Finanzas',
    duration: '20 horas',
    level: 'Principiante',
    instructor: 'Roberto Silva',
    students: 3421,
    lessons: 85,
    features: [
      'Acceso de por vida',
      'Certificado de finalización',
      'Acceso móvil',
      'Plantillas de presupuesto',
      'Soporte 24/7',
      'Comunidad de inversores'
    ],
    requirements: [
      'No se requieren conocimientos previos',
      'Disposición para cambiar hábitos',
      'Compromiso con el aprendizaje'
    ],
    whatYouWillLearn: [
      'Crear y mantener un presupuesto',
      'Estrategias de ahorro efectivas',
      'Inversiones básicas y avanzadas',
      'Emprendimiento y negocios',
      'Planificación de jubilación',
      'Protección de patrimonio'
    ],
    certificate: true,
    lifetimeAccess: true,
    mobileAccess: true
  },
  {
    id: '6',
    title: 'Productividad y Gestión del Tiempo',
    description: 'Maximiza tu productividad y logra más en menos tiempo. Aprende técnicas probadas de gestión del tiempo y organización personal.',
    shortDescription: 'Técnicas efectivas para aumentar tu productividad y lograr tus objetivos.',
    price: 99.99,
    originalPrice: 199.99,
    image: 'https://images.unsplash.com/photo-1506784365847-bbad939e9335?w=800&h=600&fit=crop',
    category: 'Productividad',
    duration: '15 horas',
    level: 'Principiante',
    instructor: 'Laura Torres',
    students: 1892,
    lessons: 67,
    features: [
      'Acceso de por vida',
      'Certificado de finalización',
      'Acceso móvil',
      'Herramientas descargables',
      'Soporte 24/7',
      'Seguimiento de progreso'
    ],
    requirements: [
      'No se requieren conocimientos previos',
      'Disposición para cambiar hábitos',
      'Compromiso con la práctica'
    ],
    whatYouWillLearn: [
      'Técnicas de gestión del tiempo',
      'Método Pomodoro y otros sistemas',
      'Organización digital y física',
      'Establecimiento de objetivos SMART',
      'Delegación efectiva',
      'Manejo del estrés y burnout'
    ],
    certificate: true,
    lifetimeAccess: true,
    mobileAccess: true
  }
]; 